import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment Occasion on Occasion {
    uuid
    name
    desc
    tag
    default
    icon {
      href
      alt
    }
    archived
    createdAt
  }
`

export default fragment
